export default __webpack_public_path__ + "static/media/linkedIn.9adafdd5.png";